import React from "react";
import { formatValue } from "../labels";

/**
 * Сводная таблица (ТЗ п.5.7).
 * Данные — items[] за отчётный период, порядок sort_order.
 * Колонки: Показатель · План · Факт · Оценка · Статус.
 */
const SummaryTable = ({ items, lang, L }) => (
  <div className="hc-table-wrap">
    <table className="hc-table">
      <thead>
        <tr>
          <th>{L.colIndicator}</th>
          <th className="hc-table__num">{L.colPlan}</th>
          <th className="hc-table__num">{L.colFact}</th>
          <th>{L.colAssessment}</th>
          <th>{L.colStatus}</th>
        </tr>
      </thead>
      <tbody>
        {items.map((it) => {
          const name = lang === "kz" ? it.name_kz : it.name_ru;
          const unit = lang === "kz" ? it.unit_kz : it.unit_ru;
          const assessment =
            it.direction === "low" ? L.lowerBetter : L.higherBetter;
          const statusText =
            it.status === "good"
              ? L.done
              : it.status === "bad"
              ? L.notDone
              : L.noData;
          return (
            <tr key={it.code}>
              <td>
                {name}
                <span className="hc-table__unit"> · {unit}</span>
              </td>
              <td className="hc-table__num">{formatValue(it.plan)}</td>
              <td className="hc-table__num">{formatValue(it.fact)}</td>
              <td className="hc-table__dim">{assessment}</td>
              <td>
                <span className={`hc-dot hc-dot--${it.status}`} />
                {statusText}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default SummaryTable;
